import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './components/HomePage';
import { AboutPage } from './components/AboutPage';
import { ProjectsPage } from './components/ProjectsPage';
import { ContactPage } from './components/ContactPage';
import { DevBoardsPage } from './components/DevBoardsPage';
import { DevBoardDetail } from './components/DevBoardDetail';
import { FaaliyetAlanlariPage } from './components/FaaliyetAlanlariPage';
import { ProjectDetail } from './components/ProjectDetail';
import { MobileAppPage } from './components/MobileAppPage';
import { ScrollToTop } from './components/ScrollToTop';
import { pageview } from './ga';
import { CookiePolicy } from './components/CookiePolicy';
import { ContactKvkk } from './components/ContactKvkk';

function AppContent() {
  const location = useLocation();
  React.useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hakkimizda" element={<AboutPage />} />
          <Route path="/urunler" element={<ProjectsPage />} />
          <Route path="/urunler/:slug" element={<ProjectDetail />} />
          <Route path="/urunler/:productSlug/mobil-uygulama" element={<MobileAppPage />} />
          <Route path="/downloads/:productSlug" element={<MobileAppPage />} />
          <Route path="/urunler/gelistirme-kartlari" element={<DevBoardsPage />} />
          <Route path="/urunler/gelistirme-kartlari/:slug" element={<DevBoardDetail />} />
          <Route path="/faaliyet-alanlari" element={<FaaliyetAlanlariPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="/cerez-politikasi" element={<CookiePolicy />} />
          <Route path="/kvkk-iletisim-aydinlatma" element={<ContactKvkk />} />
        </Routes>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
